<template>
  <div>
    <b-card>
      <div slot="header" v-if="!add && lock">
        User Detail
      </div>
      <div slot="header" v-if="!add && !lock">
        Modify User
      </div>
      <div slot="header" v-if="add && !lock">
        Create User
      </div>

      <b-row>
        <b-col md="3">
          <b-form-group class="text-primary" label="Enable" label-for="ph_is_use">
            <c-switch color="info" v-if="(profile.id != model.id) && !lock" label size="lg" id="ph_is_use" v-model="model.is_use"/>
            <label v-if="(profile.id == model.id) || lock">{{model.is_use}}</label>
            <span v-if="profile.id != model.id && lock">
              <b-button class="ml-2" size="sm" variant="primary" @click="setEnable(true)" v-if="model.is_use == false"> Set Enable </b-button>
              <b-button class="ml-2" size="sm" variant="light" @click="setEnable(false)" v-if="model.is_use == true"> Set Disable </b-button>
            </span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="lock">
        <b-col>
          <b-form-group class="text-primary">
            <label for="ph_last_login">Last Login</label>
            <b-input type="text" v-bind:value="model.last_login | datetime" plaintext></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group class="text-primary">
            <label for="ph_username">ID</label>
            <b-input type="text" v-if="add" id="ph_username" v-model="model.username" :plaintext="lock" placeholder="ID"></b-input>
            <b-input type="text" v-if="lock || !add" v-model="model.username" plaintext></b-input>
          </b-form-group>
        </b-col>
      </b-row>
            <b-row>
        <b-col>
          <b-form-group class="text-primary">
            <label for="ph_name">Name</label>
            <b-input type="text" id="ph_name" v-model="model.name" :plaintext="lock" placeholder="Name"></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="add || !lock">
        <b-col>
          <b-form-group>
            <label class="text-primary" for="ph_password">Password</label>
            <b-input type="password" v-if="!lock" id="ph_password" v-model="model.password" placeholder="Password"></b-input>
            <label class="mt-2 ml-1" v-if="!add">* 변경시에만 입력하세요.</label>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="add || !lock">
        <b-col>
          <b-form-group class="text-primary">
            <label for="ph_password_repeat">Confirm Password </label>
            <b-input type="password" v-if="!lock" id="ph_password_repeat" v-model="model.password_repeat" placeholder="Confirm Password"></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group class="text-primary">
            <label for="ph_permission">Permission</label>
            <b-form-radio class="mb-1" v-if="profile.id != model.id && !lock" v-model="model.permission" value="Master" name="some-radios">관리자</b-form-radio>
            <b-form-radio class="mb-1" v-if="profile.id != model.id && !lock" v-model="model.permission" value="User" name="some-radios">사용자</b-form-radio>
            <b-form-radio v-if="profile.id != model.id && !lock" v-model="model.permission" value="License" name="some-radios">라이센스</b-form-radio>
            <b-input type="text" v-if="(profile.id == model.id) || lock" v-model="model.permission" plaintext></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group class="text-primary">
            <label for="ph_memo">Memo</label>
            <b-textarea type="text" v-if="!lock" id="ph_memo" v-model="model.memo" rows="5" placeholder="Memo..."></b-textarea>
            <b-textarea type="text" v-if="lock" v-model="model.memo" plaintext></b-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-button size="sm" variant="light" @click="back"> Back </b-button>
      <template v-if="lock">
        <div class="float-right">
          <b-button class="mr-1" size="sm" variant="primary" @click="edit"> Modify </b-button>
          <b-button size="sm" variant="danger" @click="confirm = true" v-if="profile.id != model.id"> Delete </b-button>
        </div>
      </template>
      <template v-else>
        <div class="float-right">
          <b-button class="mr-1" size="sm" variant="danger" @click="cancel"> Cancel </b-button>
          <b-button size="sm" variant="primary" @click="save"> Save </b-button>
        </div>
      </template>
    </b-card>
    <b-modal title="Confirm - Delete user account" class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      Deleted data cannot be reversed. Are you sure?
    </b-modal>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { api, auth } from '@/f1/service';
import * as forge from 'node-forge'
// import reg from '@/f1/reg'
import 'vue-select/dist/vue-select.css';

const default_model = () => ({ is_use: true, permission: 'User' });
export default {
  components: { cSwitch, vSelect},
  data : () => ({
      confirm: false,
      add: false,
      lock: true,
      model : default_model(),
      allowed: false,
      profile: auth.profile
  }),
  computed: {
    last_info() { return `${this.$options.filters.sdate(this.model.last_visit)} @ ${this.model.last_addr}`; }
  },
  methods: {
    cancel() { this.$router.replace({ name: 'user', params: { id: this.model.id }}); },
    edit() { this.$router.replace({ name: 'user', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try {
        await api.member.user.delete(this.model.id);
        this.$emit('refresh'); this.$toastr.s('User deleted.'); this.list();
      } catch(e) { this.$toastr.e(e.data || e); this.list(); }
    },
    back() { this.$router.go(-1); },
    list() { this.$router.push({ name: 'user'}); },
    async setEnable(flag){
      try{
        if(flag){
            await api.member.user.enable(this.model.id);
            this.model.is_use = true;
        } else {
            await api.member.user.disable(this.model.id);
            this.model.is_use = false;
        }
        this.$toastr.s('Done.'); this.$emit('refresh');
      } catch(e){
        this.$toastr.e(e.data || e); this.cancel();
      }
    },
    async save() {
      if(!(this.model.name || '').trim()) { return this.$toastr.e('Name required.'); }
      if(!(this.model.username || '').trim()) { return this.$toastr.e('Username required.'); }
      try {
        if(this.model.id) {
          if((this.model.password || this.model.password_repeat) && this.model.password != this.model.password_repeat) { return this.$toastr.e('Password and repeat doesn\' match.'); }
          if(this.model.password_repeat) { this.model.password = forge.sha256.create().update(this.model.password_repeat).digest().toHex(); }

          await api.member.user.update(this.model);
        }
        else {
          if(!(this.model.password || '').trim()) { return this.$toastr.e('Password required.'); }
          if(this.model.password && this.model.password != this.model.password_repeat) { return this.$toastr.e('Password and repeat doesn\' match.'); }
          if(this.model.password_repeat) { this.model.password = forge.sha256.create().update(this.model.password_repeat).digest().toHex(); }

          this.model.id = +(await api.member.user.add(this.model));
        }
        this.$toastr.s('Done.'); this.$emit('refresh'); this.cancel();
      } catch(e) { this.$toastr.e(e.data || e); this.cancel(); }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      console.log('[vue] user.detail', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
      else { this.add = false; }

      this.lock = (tag !== 'edit');
      try { this.model = Object.assign({}, this.model, await api.member.user.get(id)); }
      catch(e) { console.log(e); this.$toastr.e(e.data || e); this.list(); }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); console.log(from) } },
  created() { console.log('[vue] user.detail', 'created'); },
  destroyed() { console.log('[vue] user.detail', 'destroyed'); },
  mounted() {
    console.log('[vue] user.detail', 'mounted');
    // this.levels = _.take(this.levels, _.indexOf(this.levels, auth.profile.level) + 1);
    this.get(this.$route.params);
  },
}
</script>
